export class OfflineEditBlockedError extends Error {
  constructor(message = "Editing requires a connection.") {
    super(message);
    this.name = "OfflineEditBlockedError";
  }
}
